import PropTypes from 'prop-types'
import cn from 'classnames'

import { ReactComponent as IconArrowLeft } from 'assets/icons/pagination/IconArrowLeft.svg'
import { ReactComponent as IconArrowRight } from 'assets/icons/pagination/IconArrowRight.svg'
import { ReactComponent as IconDoubleArrowLeft } from 'assets/icons/pagination/IconDoubleArrowLeft.svg'
import { ReactComponent as IconDoubleArrowRight } from 'assets/icons/pagination/IconDoubleArrowRight.svg'
import { paginationPagesSlice } from 'utils/pagiationPagesSlice'
import { determinePaginationButtonState } from 'utils/Pagination/determinePaginationButtonState'

const PaginationButtons = ({
  handleClickPage,
  totalPages,
  currentPage,
  totalItemsCount,
}) => {
  const pagesSlice = paginationPagesSlice(totalPages, currentPage)

  const {
    isNextPageDisabled,
    isDoubleNextPageDisabled,
    isPrevPageDisabled,
    isDoublePrevPageDisabled,
  } = determinePaginationButtonState(currentPage, totalPages, totalItemsCount)

  return (
    <div className="pagination-buttons">
      <button
        className="pagination-buttons__nav-btn"
        onClick={() => handleClickPage(1)}
        disabled={isDoublePrevPageDisabled}
      >
        <IconDoubleArrowLeft />
      </button>
      <button
        className="pagination-buttons__nav-btn pagination-buttons__prev-btn"
        onClick={() => handleClickPage(currentPage - 1)}
        disabled={isPrevPageDisabled}
      >
        <IconArrowLeft />
      </button>
      <ul className="pagination-buttons__pages-list">
        {pagesSlice?.map((page, index) => {
          if (page === 'divider') {
            return (
              <li key={index} className="pagination-buttons__page-item">
                ...
              </li>
            )
          } else {
            return (
              <li
                key={index}
                className={cn('pagination-buttons__page-item', {
                  '-active': page === currentPage,
                })}
              >
                <button
                  className="pagination-buttons__page-button"
                  onClick={() => handleClickPage(page)}
                  disabled={page === currentPage}
                >
                  {page}
                </button>
              </li>
            )
          }
        })}
      </ul>
      <button
        className="pagination-buttons__nav-btn pagination-buttons__next-btn"
        onClick={() => handleClickPage(currentPage + 1)}
        disabled={isNextPageDisabled}
      >
        <IconArrowRight />
      </button>
      <button
        className="pagination-buttons__nav-btn"
        onClick={() => handleClickPage(totalPages)}
        disabled={isDoubleNextPageDisabled}
      >
        <IconDoubleArrowRight />
      </button>
    </div>
  )
}

export default PaginationButtons

PaginationButtons.propTypes = {
  handleClickPage: PropTypes.func,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  totalItemsCount: PropTypes.number,
}
